import logo from "./brandlogo.png"
import logoYellow from "./brandlogoYellow.png"

const generalAssets = {
    brandLogo:{
        logo,logoYellow
    }
}

export default generalAssets